import React from "react";
import PropTypes from "prop-types";
import StyledSettings, {
  StyledSettingsItem,
  SettingsItemContorl,
  StyledSettingsGroup,
} from "./style";
import "styled-components/macro";

// icons
import { ReactComponent as ArrowMenuRight } from "assets/icons/arrowRight.svg";

import { Link } from "react-router-dom";

// 组件
import Seperator from "components/Seperator";
import Paragraph from "components/Paragraph";
import Switch from "components/Switch";
import Icon from "components/Icon";

import { animated, useSpring } from "react-spring";

function Settings({ children, ...rest }) {
  const animeProps = useSpring({
    transform: "translate3d(0px,0px,0px)",
    opacity: 1,
    from: { transform: "translate3d(100px,0px,0px)", opacity: 0 },
    config: {
      tension: 140,
    },
    delay: 300,
  });
  return (
    <StyledSettings {...rest}>
      <animated.div style={animeProps}>
        <SettingGroup groupName="隐私设置">
          <SettingsItem label="添加好友需要验证" />
          <SettingsItem
            label="推荐通讯录好友"
            description="上传的通讯录只用来匹配好友列表,本应用不会记录和发送任何信息给其他机构"
          />
          <SettingsItem label="只能通过手机号找到我" />
        </SettingGroup>
        <SettingGroup groupName="通知设置">
          <SettingsItem label="新消息通知" />
          <SettingsItem label="语音和视频通话提醒" />
          <SettingsItem label="显示通知详情" />
          <SettingsItem label="声音" />
          <Link
            to={`/settings/blocked`}
            css={`
              text-decoration: none;
              color: inherit;
            `}
          >
            <SettingsItem label="查看已静音好友列表" type="menu" />
          </Link>
        </SettingGroup>
      </animated.div>
    </StyledSettings>
  );
}

function SettingGroup({ groupName, children, ...rest }) {
  return (
    <StyledSettingsGroup>
      <Paragraph size="xxlarge" style={{ paddingBottom: "24px" }}>
        {groupName}
      </Paragraph>
      {children}
    </StyledSettingsGroup>
  );
}

export function SettingsItem({ type = "switch", label, description, ...rest }) {
  return (
    <StyledSettingsItem {...rest}>
      <SettingsItemContorl>
        <Paragraph size="large">{label}</Paragraph>
        {type === "switch" && <Switch />}
        {type === "menu" && <Icon icon={ArrowMenuRight} />}
      </SettingsItemContorl>
      {description && (
        <Paragraph type="secondary" style={{ margin: "4px 0" }}>
          {description}
        </Paragraph>
      )}
      <Seperator style={{ marginTop: "8px", marginBottom: "20px" }} />
    </StyledSettingsItem>
  );
}

Settings.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  groupName: PropTypes.string,
  children: PropTypes.any,
};

export default Settings;
